/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChannelUserAdminDto } from '../models/ChannelUserAdminDto';
import type { Pagination1OfChannelUserAdminDto } from '../models/Pagination1OfChannelUserAdminDto';
import type { PostChannelUserAdmin } from '../models/PostChannelUserAdmin';
import type { PutChannelUserAdmin } from '../models/PutChannelUserAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChannelUsersService {
    /**
     * **Required Policy:** `ViewChannelUsers`
     * @returns ChannelUserAdminDto OK
     * @throws ApiError
     */
    public static getChannelUserAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ChannelUserAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channelusers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannelUsers`
     * @returns ChannelUserAdminDto OK
     * @throws ApiError
     */
    public static putChannelUserAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutChannelUserAdmin,
    }): CancelablePromise<ChannelUserAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/channelusers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteChannelUsers`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteChannelUserAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/channelusers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannelUsers`
     * @returns ChannelUserAdminDto OK
     * @throws ApiError
     */
    public static getChannelUserAdmin1({
        id,
    }: {
        id: string,
    }): CancelablePromise<ChannelUserAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channelusers/user/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannelUsers`
     * @returns Pagination1OfChannelUserAdminDto OK
     * @throws ApiError
     */
    public static getChannelUsersAdmin({
        userId,
        channelId,
        page,
        limit,
    }: {
        userId?: string,
        channelId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfChannelUserAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channelusers',
            query: {
                'userId': userId,
                'channelId': channelId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannelUsers`
     * @returns ChannelUserAdminDto Created
     * @throws ApiError
     */
    public static postChannelUserAdmin({
        requestBody,
    }: {
        requestBody?: PostChannelUserAdmin,
    }): CancelablePromise<ChannelUserAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/channelusers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ChannelUserAdminDto OK
     * @throws ApiError
     */
    public static getCurrentChannelUserAdmin(): CancelablePromise<ChannelUserAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channelusers/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
